import { $get, $post } from '@js/request'

export async function validateRequest (verification: string): Promise<void> {
  const res = await $post('/api/common/vedio/verificationCheck', { verification })
  return res.data
}

export interface DataSchema { id: string, name: string, type: string, url: string }

export async function getListRequest (): Promise<DataSchema[]> {
  const res = await $get('/api/common/vedio/getInfos')
  return res.data
}

export async function clickRequest (id: string, name: string): Promise<void> {
  const res = await $post('/api/common/vedio/vedioRecordClick', {
    id, name
  })
  return res.data
}
